export default "__VITE_ASSET__Dpw1lmUb__"